import { Base } from "@/components/ImageGallery/components/base";
import { MainSwiper } from "@/components/ImageGallery/components/mainSwiper";
import { NextButton } from "@/components/ImageGallery/components/nextButton";
import { PreviousButton } from "@/components/ImageGallery/components/previousButton";
import { ThumbSwiper } from "@/components/ImageGallery/components/thumbSwiper";

export const ImageGallery = Object.assign(Base, {
    MainSwiper: MainSwiper,
    ThumbSwiper: ThumbSwiper,
    NextButton: NextButton,
    PreviousButton: PreviousButton
});
